module.exports = __webpack_public_path__ + "static/media/1015147.10aa8777.jpg";